// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"2957":"c0d118e904f8b9d7f169","5338":"d573e7a879e107106119"}[chunkId] + ".js";
};